import { useEffect, useState } from 'react';
import { extractYouTubeVideoId, isYouTubeVideoAvailable } from '../utils/youtube';

const useYouTubeAvailability = (url) => {
  const [isUnavailable, setIsUnavailable] = useState(false);

  useEffect(() => {
    const videoId = extractYouTubeVideoId(url);
    if (!videoId) {
      setIsUnavailable(false);
      return;
    }

    let cancelled = false;

    isYouTubeVideoAvailable(videoId).then((available) => {
      if (!cancelled) setIsUnavailable(!available);
    });

    return () => {
      cancelled = true;
    };
  }, [url]);

  return isUnavailable;
};

export default useYouTubeAvailability;
